import WeLoveThisGame from './we-love-this-game'
import WeLoveThisGamePageQuery, { WE_LOVE_THIS_GAME_QUERY } from './we-love-this-game.query'

export { WeLoveThisGamePageQuery, WE_LOVE_THIS_GAME_QUERY }

export default WeLoveThisGame
